export const isRequestAborted = (error) => {
  const code = String(error?.code || '').toUpperCase();
  const name = String(error?.name || '').toLowerCase();
  const message = String(error?.message || '').toLowerCase();

  return (
    code === 'ERR_CANCELED'
    || name === 'cancelederror'
    || message.includes('canceled')
    || message.includes('cancelled')
    || message.includes('ns_binding_aborted')
  );
};

export const isUnauthorizedError = (error) => {
  return Number(error?.response?.status) === 401;
};
